export default __webpack_public_path__ + "static/media/aside-vip-logo-platinum.71fc2b17.webp";